import React, { type JSX } from 'react';
import { autoGenerateHref } from '../../api/ContentUtil';
import { withRouter } from 'react-router';
import constants from '../../common/constants';
import { withAppContext } from '../../contexts/AppContext';
import PublicationViewer from './PublicationViewer';
import PublicationFeedbackForm from './PublicationFeedbackForm';
import { ContentType } from '@amzn/awscat-pattern-library-service-model';
import BrowserHistory from '../utils/BrowserHistory';
import { ViewerType } from '../../model/Enum';

class ReadOnlyPublicationViewer extends PublicationViewer {
  protected viewerType: ViewerType = ViewerType.PublicationReadonly;
  protected setTitle = true;

  protected reloadData = async () => {
    const { contentId, workflowId } = this.props.match.params;
    const parsedWorkflowId = parseInt(workflowId, constants.DECIMAL);

    const [
      publication,
      { workflows: historyWorkflows },
      { accessUsers: coAuthors },
      { accessUsers: peerReviewers },
      { publicationFeedbacks },
    ] = await Promise.all([
      this.mplServiceClient.getPublication(contentId),
      this.mplServiceClient.listWorkflowHistory(contentId),
      this.mplServiceClient.listContentSharedWith(contentId),
      this.mplServiceClient.listContentReviewers(contentId),
      this.mplServiceClient.listPublicationFeedbacks(contentId),
    ]);

    if (publication.content.contentMetadata.contentType === ContentType.Post) {
      BrowserHistory.push(`/post-viewer/${contentId}`);
      return null;
    }
    // Auto generate href for each content node if they are not existed.
    autoGenerateHref(publication.content.contentData, publication.content?.contentMetadata);

    this.setState({
      coAuthors,
      peerReviewers,
      isLoading: false,
      publication,
      workflowHistory: historyWorkflows,
      workflowId: parsedWorkflowId,
      publicationFeedbacks,
    });
    return null;
  };

  protected renderFeedbackForm(): false | JSX.Element {
    const { contentId } = this.props.match.params;
    const userType = this.props.appContext.authnInfo!.userProfile!.type;
    return (
      <PublicationFeedbackForm
        contentId={contentId}
        userType={userType}
        onReportToAuthor={this.handleReportToAuthor}
      />
    );
  }
}

export default withRouter(withAppContext(ReadOnlyPublicationViewer));
